/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./uc-workorder-details-modal.vue?vue&type=template&id=7a21f159&"
import script from "./uc-workorder-details-modal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./uc-workorder-details-modal.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports